import { Button, Divider, Flex, FormControl, FormLabel, HStack, Heading, IconButton, Input, Select, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { FiArrowLeft } from 'react-icons/fi';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { updatePickupPoint } from '../../store/actions';
import { useAppDispatch } from '../../hooks';
import { useFormik } from 'formik';

export const EditPickupPoint = () => {

    const [origin, setOrigin] = useState<any | null>(null);

    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { state } = location;
    const { pickup_point } = state;

    const editPickupPointForm = useFormik({
        initialValues: {
            pickup_point_id: '',
            name: '',
            address: '' || pickup_point?.address,
            email: '',
            phone: '',
            is_active: true,
            operating_hours: {
                monday: {
                    open: '-',
                    close: '-'
                },
                tuesday: {
                    open: '-',
                    close: '-'
                },
                wednesday: {
                    open: '-',
                    close: '-'
                },
                thursday: {
                    open: '-',
                    close: '-'
                },
                friday: {
                    open: '-',
                    close: '-'
                },
                saturday: {
                    open: '-',
                    close: '-'
                },
                sunday: {
                    open: '-',
                    close: '-'
                },
            }
        },
        validateOnBlur: true,
        onSubmit: (values) => {
            editPickupPointForm.setSubmitting(true);
            dispatch(updatePickupPoint({ ...pickup_point, ...values }))
                .then(() => navigate('/pickup-points'))
                .finally(() => editPickupPointForm.setSubmitting(false));
        }
    });

    const updateFormFields = useCallback(() => {
        editPickupPointForm.setFieldValue('pickup_point_id', pickup_point?.pickup_point_id);
        editPickupPointForm.setFieldValue('name', pickup_point?.name);
        editPickupPointForm.setFieldValue('email', pickup_point?.email);
        editPickupPointForm.setFieldValue('phone', pickup_point?.phone);
        editPickupPointForm.setFieldValue('is_active', pickup_point?.is_active);
        editPickupPointForm.setFieldValue('operating_hours.monday.open', pickup_point?.operating_hours.monday.open);
        editPickupPointForm.setFieldValue('operating_hours.monday.close', pickup_point?.operating_hours.monday.close);
        editPickupPointForm.setFieldValue('operating_hours.tuesday.open', pickup_point?.operating_hours.tuesday.open);
        editPickupPointForm.setFieldValue('operating_hours.tuesday.close', pickup_point?.operating_hours.tuesday.close);
        editPickupPointForm.setFieldValue('operating_hours.wednesday.open', pickup_point?.operating_hours.wednesday.open);
        editPickupPointForm.setFieldValue('operating_hours.wednesday.close', pickup_point?.operating_hours.wednesday.close);
        editPickupPointForm.setFieldValue('operating_hours.thursday.open', pickup_point?.operating_hours.thursday.open);
        editPickupPointForm.setFieldValue('operating_hours.thursday.close', pickup_point?.operating_hours.thursday.close);
        editPickupPointForm.setFieldValue('operating_hours.friday.open', pickup_point?.operating_hours.friday.open);
        editPickupPointForm.setFieldValue('operating_hours.friday.close', pickup_point?.operating_hours.friday.close);
        editPickupPointForm.setFieldValue('operating_hours.saturday.open', pickup_point?.operating_hours.saturday.open);
        editPickupPointForm.setFieldValue('operating_hours.saturday.close', pickup_point?.operating_hours.saturday.close);
        editPickupPointForm.setFieldValue('operating_hours.sunday.open', pickup_point?.operating_hours.sunday.open);
        editPickupPointForm.setFieldValue('operating_hours.sunday.close', pickup_point?.operating_hours.sunday.close);
    }, []);

    useEffect(() => {
        updateFormFields();
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack bgColor={'white'} borderRadius={6} p={6}>
                    <HStack spacing={6}>
                        <IconButton
                            aria-label={'Go back'}
                            icon={<FiArrowLeft />}
                            onClick={() => navigate('/pickup-points')}
                        />
                        <Heading size={'md'}>Edit Pickup Point.</Heading>
                    </HStack>
                    <Divider py={2} />
                    <Stack pt={4}>
                        <form onSubmit={editPickupPointForm.handleSubmit}>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Name</FormLabel>
                                <Input
                                    name='name'
                                    type='text'
                                    value={editPickupPointForm.values.name}
                                    onChange={editPickupPointForm.handleChange}
                                    onBlur={editPickupPointForm.handleBlur}
                                    isDisabled
                                />
                                {editPickupPointForm.errors.name && <Text fontSize='sm' color='red.400'>{editPickupPointForm.errors.name}</Text>}
                            </FormControl>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Address</FormLabel>
                                <GooglePlacesAutocomplete
                                    apiKey='AIzaSyCsvDO2ZMssvwhcmIo2TqXvJSL0zlMD5bw'
                                    apiOptions={{ region: 'za' }}
                                    selectProps={{
                                        placeholder: pickup_point?.address,
                                        origin,
                                        onChange: setOrigin,
                                    }}
                                />
                                {/* <Input name='address' type="text" value={companyForm.values.address} onChange={companyForm.handleChange} /> */}
                                {(!pickup_point?.address || !editPickupPointForm?.values?.address) && <Text fontSize='sm' color='red.400'>{'Enter your address'}</Text>}
                            </FormControl>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Email</FormLabel>
                                <Input
                                    name='email'
                                    type='email'
                                    value={editPickupPointForm.values.email}
                                    onChange={editPickupPointForm.handleChange}
                                    onBlur={editPickupPointForm.handleBlur}
                                />
                                {editPickupPointForm.errors.email && <Text fontSize='sm' color='red.400'>{editPickupPointForm.errors.email}</Text>}
                            </FormControl>
                            <SimpleGrid columns={[1, 2, 2, 2, 2]} spacing={3}>
                                <FormControl mb={3} isRequired>
                                    <FormLabel>Phone</FormLabel>
                                    <Input
                                        name='phone'
                                        type='text'
                                        maxW={'350px'}
                                        value={editPickupPointForm.values.phone}
                                        onChange={editPickupPointForm.handleChange}
                                        onBlur={editPickupPointForm.handleBlur}
                                    />
                                    {editPickupPointForm.errors.phone && <Text fontSize='sm' color='red.400'>{editPickupPointForm.errors.phone}</Text>}
                                </FormControl>
                                <FormControl isRequired>
                                    <FormLabel>Active</FormLabel>
                                    <Select name='is_active' value={`${editPickupPointForm.values.is_active}`} onChange={editPickupPointForm.handleChange} onBlur={editPickupPointForm.handleBlur}>
                                        <option value={'true'}>True</option>
                                        <option value={'false'}>False</option>
                                    </Select>
                                    {editPickupPointForm.errors.is_active && <Text color={'red.500'} fontSize={'sm'}>{editPickupPointForm.errors.is_active}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <Divider my={3} />
                            <Text fontWeight={'semibold'}>Operating hours</Text>
                            <SimpleGrid mt={3} columns={[1, 2, 2, 2, 2]} spacing={4}>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Monday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.monday.open'
                                            value={editPickupPointForm.values.operating_hours.monday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.monday.close'
                                            value={editPickupPointForm.values.operating_hours.monday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Tuesday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.tuesday.open'
                                            value={editPickupPointForm.values.operating_hours.tuesday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.tuesday.close'
                                            value={editPickupPointForm.values.operating_hours.tuesday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Wednesday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.wednesday.open'
                                            value={editPickupPointForm.values.operating_hours.wednesday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.wednesday.close'
                                            value={editPickupPointForm.values.operating_hours.wednesday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Thursday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.thursday.open'
                                            value={editPickupPointForm.values.operating_hours.thursday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.thursday.close'
                                            value={editPickupPointForm.values.operating_hours.thursday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Friday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.friday.open'
                                            value={editPickupPointForm.values.operating_hours.friday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.friday.close'
                                            value={editPickupPointForm.values.operating_hours.friday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Saturday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.saturday.open'
                                            value={editPickupPointForm.values.operating_hours.saturday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.saturday.close'
                                            value={editPickupPointForm.values.operating_hours.saturday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                                <HStack justifyContent={'space-between'}>
                                    <Stack>
                                        <Text>Sunday</Text>
                                    </Stack>
                                    <HStack>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.sunday.open'
                                            value={editPickupPointForm.values.operating_hours.sunday.open}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                        <Text>-</Text>
                                        <Input
                                            placeholder=''
                                            size='sm'
                                            type='time'
                                            name='operating_hours.sunday.close'
                                            value={editPickupPointForm.values.operating_hours.sunday.close}
                                            onChange={editPickupPointForm.handleChange}
                                            onBlur={editPickupPointForm.handleBlur}
                                        />
                                    </HStack>
                                </HStack>
                            </SimpleGrid>
                            <FormControl mt={3}>
                                <Button
                                    colorScheme={'yellow'}
                                    float={'right'}
                                    type={'submit'}
                                    isDisabled={editPickupPointForm.isSubmitting || !editPickupPointForm.isValid}
                                    isLoading={editPickupPointForm.isSubmitting}
                                >
                                    Submit
                                </Button>
                            </FormControl>
                        </form>
                    </Stack>
                </Stack>
            </Flex>
        </>
    );
};